
import {computed, ComputedRef, defineComponent, PropType} from "vue";
import {Course} from "../../../../domain/entities/entities";
import ModalIntroductoryContent from "./ModalIntroductoryContent.vue";
import VideoPlayButton from "./buttons/VideoPlay.vue";
import ButtonComment from "./DashboardComments/ButtonComment.vue";
import ProgressBar from "./ProgressBar.vue";
import {useRouter} from "vue-router";
import {useCarouselMouseEvents} from "../composables/carousel_mouse_events";
import {Content} from "../../views/content/helpers";
import {useStore} from "vuex";
import {dispatchErrorBox} from "../mixins";
import {ContentProviderType} from "../../../../domain/entities/content-provider/content-provider";

;

const __default__ = defineComponent({
  components: {
    ProgressBar,
    ButtonComment,
    ModalIntroductoryContent,
    VideoPlayButton
  },
  props: {
    course: {
      type: Object as PropType<Course>,
      required: true
    }
  },
  setup(props) {
    const router = useRouter();
    const store = useStore();

    const backgroundImage: ComputedRef<string> = computed(() => {
      return `url(${props.course.imageURL})`;
    });
    /** Boolean used to tell when a click event has been fired
     * from below the `div.card` in the DOM tree. */
    let hasLowLevelActions = false;

    const { isAllowedToClick: isAllowedToGoToCourse } = useCarouselMouseEvents(
      "course-card"
    );
    const contents: ComputedRef<Content[]> = computed(
      (): Content[] => store.getters["content_module/contents"]
    );

    const loadContents = async (): Promise<void> => {
      try {
        await store.dispatch("content_module/loadContentProvider", {type: ContentProviderType.COURSE, ids: {providerID: props.course.id}})
        await store.dispatch("content_module/loadAllContents");
      } catch (e) {
        console.error(e);
        await dispatchErrorBox(e);
      }
    };

    /** Redirects the user to the first content_provider that is not finished */
    async function redirectToContent(): Promise<void> {
      await loadContents();
      const notFinishedContents = contents.value.filter(
        content => content.status.progress !== 100 && !content.isBlocked && content.isReleased
      );
      const currentContent: Content = notFinishedContents.length
        ? notFinishedContents[0]
        : contents.value[0];

      await router.push({
        name: "course_content",
        params: { course_id: props.course.id, content_id: currentContent.id }
      });
    }

    const goToCourse = async (): Promise<void> => {
      if (isAllowedToGoToCourse.value && !hasLowLevelActions) {
        await redirectToContent();
      }
      hasLowLevelActions = false;
    };

    return {
      backgroundImage,
      goToCourse
    };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "39372841": (_ctx.backgroundImage)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__